<template>
  <div>
    <app-page-container extra>
      <app-flex-grid :rows="[['240px', '220px', 1, '240px']]">
        <template #col-1-1>
          <app-input
            @input.native="onReservationSearch"
            v-model="search"
            type="search"
            placeholder="Search by client, lead number"
            name="search"
          />
        </template>
        <template #col-1-2>
          <app-select
            @input="onChangeFilters"
            v-model="reservation_manager"
            :options="reservation_manager_options"
            :reduce="item => item.id"
            :filterable="false"
            :searchable="false"
            label="full_name"
            placeholder="Reservation manager"
          />
        </template>
        <template #col-1-3>
          <app-select
            @input="onChangeFilters"
            v-model="filter_hotel"
            :reduce="item => item.id"
            :options="filter_hotel_options"
            placeholder="Hotel"
          />
        </template>
        <template #col-1-4>
          <app-select
            v-if="is_general_manager || is_sales_supervisor || is_reservations_department"
            @input="onChangeFilters"
            v-model="sales_manager"
            :reduce="item => item.id"
            :options="sales_manager_options"
            label="full_name"
            placeholder="Sales manager"
          />
        </template>
      </app-flex-grid>
    </app-page-container>
    <app-spinner v-if="!is_loaded" />
    <app-page-container v-else extra>
      <template v-if="reservations.length">
        <AppAccHotel
          v-for="(reservation, index) in reservations"
          :key="reservation.id"
          :reservation="reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination.count" :count="reservations.length" :page="pagination.page" />
        </app-cells>
      </template>
      <app-no-results v-else text="There’s no bookings yet" />
    </app-page-container>
  </div>
</template>

<script>
import { getHotelsListSearch, getReservationsHotelsList, getUsers } from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'HotelsReservationsListCancelled',
  components: { AppAccHotel },
  data() {
    return {
      is_loaded: false,
      reservations: [],
      search: null,
      reservation_manager: null,
      reservation_manager_options: [],
      filter_hotel: null,
      filter_hotel_options: [],
      sales_manager: null,
      sales_manager_options: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_reservations_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
  created() {
    this.fetchItems()
    getUsers({ is_active: true, group: 'reservation_supervisor,reservation_manager,reservation_supervisor' })
      .then(res => { this.reservation_manager_options = res.data })
    getHotelsListSearch({ active: true }).then(res => { this.filter_hotel_options = res.data })
    getUsers({ group: 'sales_manager', is_active: true }).then(response => { this.sales_manager_options = response.data })
  },
  methods: {
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      getReservationsHotelsList({
        sales_status: 'cancel',
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        hotel_id: this.filter_hotel,
        sales_manager: this.sales_manager,
        page: this.pagination.page,
        page_size: 20,
      })
        .then(res => {
          this.reservations = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.is_loaded = true
        })
    },
    onReservationSearch() {
      this.category_filter = ''
      this.reservation_manager = ''
      this.filter_hotel = null
      this.sales_manager = null
      this.searchReservation(this)
      this.is_loaded = false
    },
    searchReservation: debounce(vm => {
      vm.fetchItems()
    }, 350),
    onChangeFilters() {
      this.is_loaded = false
      this.search = ''
      this.fetchItems()
    },
  }
}
</script>
